import { type ModalFuncProps } from 'ant-design-vue'
import { confirm } from '~/features/modal'
import AntProvider from '~/features/provider/instance.vue'

export const Wrapper = defineComponent({
  props: {
    source: String as PropType<SOURCE>,
  },
  setup(props, { slots }) {
    if (props.source) {
      provideResourceLocation({
        source: props.source,
      })
    }

    return () => slots.default?.()
  },
})

export const instances = new Set()

export const clearModals = () => {
  instances.forEach((modal: any) => {
    modal.destroy()
    instances.delete(modal)
  })
}

export const useEmptyModal = (
  options: ModalFuncProps & { source?: SOURCE },
  clear?: boolean
) => {
  if (clear) {
    clearModals()
  }

  const modal = confirm({
    footer: false,
    icon: null,
    centered: true,
    wrapClassName: 'xmov-empty-modal',
    ...options,
    content: () => (
      <AntProvider>
        <Wrapper source={options.source}>
          <options.content></options.content>
        </Wrapper>
      </AntProvider>
    ),
  })

  modal.then((res) => {
    instances.add(res)
    return res
  })

  return {
    destroy: () => {
      return modal.then((res) => {
        instances.delete(modal)
        res.destroy()
      })
    },
  }
}
